<template>
  <div id="todo-list">

    <!-- 성취율 표시 -->
    <div class="progress">
      <strong><h4>완료</h4></strong>&nbsp;
      <div class="progress-bar progress-bar-striped active" role="progressbar"
      aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: done + '%'}">
        {{ done }}%
      </div>
    </div>

    <!-- 카테고리 및 검색 -->
    <div>
      <b-form inline>
        <b-form-select v-model="selected" :options="ctgs" id="ctg">
            <option :value="null">전체보기</option>
        </b-form-select>
        <b-form-input id="search" type="text" v-model="search" placeholder="Search todo"></b-form-input>
      </b-form>
    </div>

    <!-- 할일 목록 리스트 -->
    <div>
        <transition-group name="list" tag="ul" class="todolist">
          <li v-for="todoItem in filteredTodos" :key="todoItem.id" class="shadow">
            <span class="completeBtn" v-on:click="doneTodo(todoItem)">
              <i class="fas fa-check fa-2x" aria-hidden="true"></i>
            </span>
            <span class="ctg">{{ todoItem.ctg }}</span>
            <span class="title">{{ todoItem.title | summarize}}</span>
            <span class="deadline">{{ todoItem.deadline }}</span>
            <span class="label-default viewBtn">
              <router-link v-bind:to="{name:'Todoview', params: {todo_id: todoItem.id}}">
                <i class="fa fa-eye"></i>
              </router-link>
            </span>
            <span class="label-default removeBtn" v-on:click="removeTodo(todoItem.id)">
              <i class="far fa-trash-alt fa-1.5x" aria-hidden="true"></i>
            </span>
          </li>
        </transition-group>
          <b-row class="addBtn">
          <div>
            <router-link to="/create">
              <i class="fas fa-plus-circle fa-3x"></i>
            </router-link>
          </div>
          </b-row>
    </div>

    <!-- 완료 목록 리스트 -->
    <h3>Mission Complete</h3>
    <div>
      <transition-group name="list" tag="ul" class="donelist">
        <li v-for="todoItem in doneTodos" :key="todoItem.id" class="shadow">
          <span class="completeBtn" v-on:click="doneTodo(todoItem)">
            <i class="fas fa-check fa-2x" aria-hidden="true"></i>
          </span>
          <span class="ctg">{{ todoItem.ctg }}</span>
          <span class="title">{{ todoItem.title | summarize}}</span>
          <span class="deadline">{{ todoItem.deadline }}</span>
          <span class="label-default viewBtn">&nbsp;</span>
          <span class="label-default removeBtn" v-on:click="removeTodo(todoItem.id)">
            <i class="far fa-trash-alt fa-1.5x" aria-hidden="true"></i>
          </span>
        </li>
      </transition-group>
    </div>

    <!--진동 알림 창 -->
    <modal v-if="showModal" v-on:click="showModal = false" class="alarm">
      <span slot="header">
        <h3 style="color:red;">마감 하루 전</h3>
      </span>
      <span slot="footer" class="alarmmodal">
        <div name="list" tag="ul" class="alarmlist">
          <li v-for="todoItem in deadlineTodos" :key="todoItem.id" class="shadow">
            <span class="alarmCtg">{{ todoItem.ctg }}</span>
            <span class="alarmTitle">{{ todoItem.title | summarize }}</span>
          </li>
        </div>
        <b-button variant="success"  v-on:click="showModal=false" style="margin-top:2rem;">확인</b-button>
      </span>
    </modal> 
    
  </div>
</template>


<script>
import { authRef, dbRef } from '../store/db.js';
import Modal from './common/Modal.vue';

export default {
  data(){
    return{
      selected: null,
      search: '',
      user:'',
      text: '',
      showModal: true,
    }
  },
  methods: {
    removeTodo(id) {
      if(confirm('Are you sure?')){
          this.$store.dispatch('BinTodo',id);
      }
    },
    doneTodo(todo){
      this.$store.dispatch('DoneTodo',todo);
    }
  },
  computed: {
    filteredTodos: function(){
      return this.$store.getters.getTodos.filter((todo) => {
        if(this.user == todo.user && (!todo.remove) && (!todo.status)){
          if(this.selected == null){
            this.count++; 
              return todo.title.match(this.search);
          }
          if(todo.ctg == this.selected){
              return todo.title.match(this.search);
          }
        }
      });
      
    },
    doneTodos: function(){
      return this.$store.getters.getTodos.filter((todo) => {
        if(this.user == todo.user && (!todo.remove) && todo.status){
          if(this.selected == null){
              return todo.title.match(this.search);
          }
          if(todo.ctg == this.selected){
              return todo.title.match(this.search);
          }
        }
      })
    },
    deadlineTodos: function(){
      var year = new Date().getFullYear(); 
      var month = new Date().getMonth(); 
      var date = new Date().getDate(); 
      var today = new Date(year + "-" + (month+1) + "-" + date); 
      
      return this.$store.getters.getTodos.filter((todo) => {
          if(this.user == todo.user && (!todo.remove) && (!todo.status)){
            var oneday = 24 * 60 * 60 * 1000; 
            var deadline = new Date(todo.deadline);
            var diff = (deadline - today)/oneday; 

            if(diff>=0 && diff<=2){ 
              navigator.vibrate([2000,1000]);      
              return todo; 
            }
          }
       })
    },
    ctgs: function(){
      return this.$store.getters.getCtgs;
    },
    done: function(){
      var total = 0;
      var done = 0;
      this.$store.getters.getTodos.filter((todo) => {
        if(this.user == todo.user && (!todo.remove))total++;
        if(this.user == todo.user && (!todo.remove) && todo.status) done++;
      });
      if(done == 0){
        return 0;
      }else{
          return Math.round(done/total*100);
      }

    }
  },
  filters:{
    summarize(value){
      if(value.length > 10){
        return value = value.substr(0, 10) + "......";
      } else{
        return value;
      }
    }
  },
  beforeCreate(){
      authRef.onAuthStateChanged(user=>{
          if(!user) this.$router.push('/');
          else{
              this.$store.commit('userAuth', user);
              this.user = this.$store.getters.getAuth.email;
          }
      });

  },
  created(){ 
    this.$store.dispatch('getTodos');
    this.$store.dispatch('getCtgs');
    
    
  },
  components: {
    Modal: Modal
  }
}
</script>


<style scoped>
  #todo-list{
    width: 100%;
    margin: 0;
    padding-left: 1rem;
    padding-right: 1rem;
    font-style: normal;
  }
  .progress{
    margin-top: 1rem;
    height: 2rem;
  }
  .progress strong {
    width: 4rem;
  }
  #ctg{
    width:20%;
  }
  #search{
    width: 80%;
  }
   ul {
    clear: both;
    list-style-type: none;
    padding-left: 0px;
    margin-top: 0;
    text-align: center;
    width: 100%;
  }
  li {
    display: flex;
    min-height: 30px;
    height: 30px;
    line-height: 30px;
    margin: 0.5rem 0;
    padding: 0 0.9rem;
    background: white;
    border-radius: 5px;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to {
    opacity: 0;
    transform: translateY(30px);
  }
  .todolist .completeBtn{
    width: 10%;
    text-align: center;
  }
  .todolist .ctg{
    width: 15%;
    text-align: center;
  }
  .todolist .title{
    width: 40%;
    text-align: center;
  }
  .todolist .deadline{
    width: 23%;
    text-align: center;
  }
  .todolist .viewBtn{
    width: 6%;
    text-align: center;
    background: white;
  }
  .todolist .removeBtn{
    width: 6%;
    text-align: center;
    color: red;
    background: white;
  }
  .addBtn{
    padding-top: 1rem;
    padding-left: 98%;
  }
 .donelist .completeBtn{
    width: 10%;
    text-align: center;
    color: red;
  }
  .donelist .ctg{
    width: 15%;
    text-align: center;
  }
  .donelist .title{
    width: 40%;
    text-align: center;
  }
  .donelist .deadline{
    width: 23%;
    text-align: center;
  }
  .donelist .viewBtn{
    width: 6%;
    text-align: center;
    background: white;
  }
  .donelist .removeBtn{
    width: 6%;
    text-align: center;
    color: red;
    background: white;
  }
  .alarmmodal{
    width: 100%; 
    color: black; 
    margin-right: auto; 
    margin-left: auto; 
  }
  .alarmCtg{
    width: 40%;
  }
  .alarmTitle{
    width: 60%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/TodoList.vue